// getResumableMessageData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select resumable message item ids by operations
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} dataKey - select key.
 * @return {any} The selected resumable message item ids.
 */
const getResumableMessageData = createCachedSelector(
  state => state.getIn(['operations', 'message']),
  (state, dataKey) => dataKey,
  (messages, dataKey) => {
    let result = undefined;
    if ('itemIds' === dataKey) {
      const resumableMessageItemIds = messages.filter(value => {
        const progress = value.get('progress');
        return progress !== undefined && progress < 100 && progress >= -1;
      });
      result = resumableMessageItemIds.keySeq().toArray();
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((messages, dataKey) => `getResumableMessageData:${dataKey}`);

export default getResumableMessageData;
